

   const data=  [
        {
          id: "1",
          name: "Car parts shop",
          about: "this website use font end react js and use for style tailwind css backend express js frame work of node js and server side mongodb   this website has user login and signup this website use for cart parts buying user can order parts and pay for this order user can gave review this review show in home page this websie also admin panel   admin can make admin and remove admin  admin can hanlde all orders and all products  thi website use some animationthis website use stripe payment method",
          picture: "https://i.ibb.co/XYPBzqk/Screenshot-2022-06-09-183200.png",
          link: "https://car-parts-8c7dd.web.app/",
          technology: "React js, Tailwindcss, Node js, Express Js, MongoDB, Jwt, Firebase, Heroku, stripe",
          img1:"https://i.ibb.co/TrcPHdJ/screenshot.png",
          img2:"https://i.ibb.co/2hFQyBh/screenshot-1.png",
          img3:"https://i.ibb.co/4pVHdq0/screenshot-2.png"
        },
        {
          id: "2",
          name: "warehouse management",
          about: "This website is fullstack website.this website both client side and serverside.This website used reactjs,bootstrap5,expressjs,mongodb.this website used google login and email password login. this website used firebase authentication. this website used user post and delete data.this website used some animation.this website used jwt token. this website used daynamic page title. this website react router. this website used active link.this website used react icon.this website used table",
          picture: "https://i.ibb.co/mymwQJh/Screenshot-2022-06-09-183337.png",
          link: "https://assignment11-dress-shop.web.app/",
          technology: "React js, bootstrap, Node js, Express Js, MongoDB, Jwt, Firebase, Heroku,",
          img1:"https://i.ibb.co/xDCs0Y1/dress.png",
          img2:"https://i.ibb.co/CWdn6GC/dress2.png",
          img3:"https://i.ibb.co/tP2jw4S/dress3.png"
        },
        {
          id: "3",
          name: "Gym center",
          about: "website name is fitness gym center .this website made with reatc js this website added navbar,carousel,service item,fotter.this website using react router,firebase hook,custom hook,context api,nested route ,login and signup page.this website style by bootstap this website full responsive this website has checkout component.this component only log in user seen this otherwise user must be login or signup.this website also added facebook login and google login",
          link: "https://fitness-power-gym.web.app/",
          picture: "https://i.ibb.co/Cs4TczN/Screenshot-2022-06-09-183625.png",
          technology: "React js, Bootstrap, Node js, Express Js, MongoDB, Firebase, Heroku",
          img1:"https://i.ibb.co/r3sGqKz/gym.png",
          img2:"https://i.ibb.co/7yzpSPg/gym2.png",
          img3:"https://i.ibb.co/58VS6wM/gym3.png"
        },
        {
          id: "4",
          name: "Blog website",
          about: "this is blog website this website use simple node mongo crud operationBlogger can added post and saw his post Blogger can delete his post user can update his profile photo .using react.js,tailwindcss,firebase,express.js,mongodb",
          link: "https://blogs-31d7a.web.app/",
          picture: "https://i.ibb.co/cL6WKvL/Screenshot-2022-06-09-183504.png",
          technology: "React js, Tailwindcss, Node js, Express Js, MongoDB, Jwt, Firebase, Heroku",
          img1:"https://i.ibb.co/Phnht0Z/blog.png",
          img2:"https://i.ibb.co/crYCKHp/blog2.png",
          img3:"https://i.ibb.co/Y07hhJv/blog-3.png"
        },
        {
          id: "5",
          name: "Laptop review",
          about: "This a laptop review.this single frontend website.This website shown customer review 3 in home page and all review show another page.using react rechart with dashboard",
          link: "https://sparkling-phoenix-8e5872.netlify.app/",
          picture: "https://i.ibb.co/MRBFn3f/screenshot-3.png",
          technology: "React js, Bootstrap,React rechart,netlify",
          img1:"https://i.ibb.co/t2vqw6G/spa2.png",
          img2:"https://i.ibb.co/VVcLpnj/spa3.png",
          img3:"https://i.ibb.co/Mhky41Y/screenshot-4.png"
        }
      ]
    
export default data

